<script setup lang="tsx">
import type { RiskTreatment } from '@/models/api-generated'
import { getTreatmentText } from '@/services/utils'

const model = defineModel<RiskTreatment[]>({ required: true })

const rows = 3
const cols = 2

const getItem = (rowIndex: number, colIndex: number) => {
	const idx = (rowIndex - 1) * cols + (colIndex - 1)
	return model.value[idx]
}

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(treatment: string) {
	if (!treatment) return
	emit('go-to-risks', [], [treatment])
}
</script>

<template>
	<div class="rounded-container p-4 overflow-auto">
		<p class="text-center fw-bold">{{ $t('risk.riskTreatment') }}</p>

		<div>
			<div v-for="rowIndex in rows" :key="rowIndex" class="row align-items-center" :class="{ 'border-bottom': rowIndex !== rows }">
				<div
					v-for="colIndex in cols"
					:key="colIndex"
					class="col text-center d-flex flex-column justify-content-center"
					:class="{ 'border-end': colIndex === 1 }"
				>
					<template v-if="getItem(rowIndex, colIndex)">
						<div class="text-muted p-2">
							<b @click="goToRisks(getItem(rowIndex, colIndex).treatment)" class="risks-cell">{{
								getTreatmentText(getItem(rowIndex, colIndex).treatment)
							}}</b>
						</div>
						<div class="text-muted p-2">{{ getItem(rowIndex, colIndex).count }}</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
